import PropTypes from 'prop-types';
import {
  useEffect, useRef,
} from 'react';
import './PostToIframe.scss';
import Page from '../../../../enums/Page';
import getPage from '../../../page/getPage';

let frameNumber = 0;

export default function PostToIframe(props) {
  const formRef = useRef(null);
  const uniqueFrameName = `PostToIframe${frameNumber}`;
  frameNumber += 1;
  
  useEffect(() => {
    formRef.current?.submit();
    props.onSubmit();
  }, []);
  
  return (
    <div className={`PostToIframe PostToIframe--${props.hidden ? 'hidden' : 'visible'}`}>
      <form
        target={uniqueFrameName}
        className="PostToIframe__form"
        ref={formRef}
        name={`${uniqueFrameName}__form`}
        action={props.postURL}
        method="POST"
      >
        {Object.keys(props.formFields).map(key => (
          <input type="hidden" name={key} value={props.formFields[key]} key={key} />
        ))}
      </form>
      
      <iframe
        name={uniqueFrameName}
        className={getPage() === Page.PROCESSING ? 'PostToIframe__iframe--processing' : 'PostToIframe__iframe'}
        onError={props.onError}
        onLoad={props.onLoad}
        data-cs-mask
      />
    </div>
  );
}

const noop = () => {
};

PostToIframe.defaultProps = {
  onSubmit: noop, // If callbacks aren't specified, do nothing.
  onLoad: noop,
  onError: noop,
  hidden: false,
};

PostToIframe.propTypes = {
  hidden: PropTypes.bool,
  notInOverlay: PropTypes.bool,
  postURL: PropTypes.string.isRequired,
  
  // Allow object to get a generic map of field names to values.
  // eslint-disable-next-line react/forbid-prop-types
  formFields: PropTypes.object.isRequired,
  
  onSubmit: PropTypes.func,
  onLoad: PropTypes.func,
  onError: PropTypes.func,
};
